import React from "react";
import PropTypes from "prop-types";
import {appContainer, Subscribe} from "../../contexts/app";
import Sidebar from "../Sidebar";
import NavBar from "../NavBar";

export class PageContainerContent extends React.Component {
  render() {
    const {sessions, location, currentUser, sidebarOpen, onToggleSidebar} = this.props;
    return (
      <React.Fragment>
        <Sidebar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={onToggleSidebar}
          location={location}
          currentUser={currentUser}
          sessions={sessions}
        />
        <NavBar {...this.props} />
        <main className="pageContainer">{this.props.children}</main>
      </React.Fragment>
    );
  }
}

export default props => {
  return (
    <Subscribe
      to={[appContainer]}
      render={app => {
        const {facilities} = props;
        const sessions = app.state
          .get("sessions")
          .toList()
          .toJS();
        const currentUser = app.state.get("currentUser");
        const sidebarOpen = app.state.get("sidebarOpen");
        const markerTypeCategories = app.state.get("markerTypeCategories");
        const markerTypes = app.state.get("markerTypes");
        return (
          <PageContainerContent
            {...props}
            facilities={facilities}
            sessions={sessions}
            markerTypeCategories={markerTypeCategories}
            markerTypes={markerTypes}
            sidebarOpen={sidebarOpen}
            onToggleSidebar={() => {
              app.set("sidebarOpen", !sidebarOpen);
            }}
            currentUser={currentUser}
          />
        );
      }}
    />
  );
};

PageContainerContent.propTypes = {
  location: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  facilities: PropTypes.object.isRequired,
  facility: PropTypes.object,
  buildings: PropTypes.object,
  building: PropTypes.object,
  floors: PropTypes.object,
  floor: PropTypes.object,
  markers: PropTypes.object,
  marker: PropTypes.object,
  sidebarOpen: PropTypes.bool,
  editMode: PropTypes.bool
};

PageContainerContent.defaultProps = {
  sidebarOpen: false,
  editMode: true
};



// WEBPACK FOOTER //
// ./src/components/PageContainer/index.jsx